<template>
  <div class="homepage">
    <!-- 导航栏 -->
    <nav class="navbar">
      <div class="container">
        <div class="brand">广东广福宏宇保险经纪有限公司</div>

        <!-- 桌面菜单 -->
        <ul class="desktop-menu" v-if="!isMobile">
          <li>
            <router-link
              to="/"
              :class="{ active: $route.name === 'index' }"
            >
              首页
            </router-link>
          </li>
          <li>
            <router-link
              to="/product"
              :class="{ active: $route.name === 'product' }"
            >
              产品
            </router-link>
          </li>
        </ul>

        <!-- 移动端菜单按钮 -->
        <button
          class="mobile-menu-btn"
          v-if="isMobile"
          @click="showMobileMenu=!showMobileMenu"
        >☰</button>

        <!-- 移动端展开菜单 -->
        <ul class="mobile-menu" v-show="showMobileMenu">
          <li>
            <router-link
              to="/"
              @click="showMobileMenu=false"
              :class="{ active: $route.name === 'index' }"
            >
              首页
            </router-link>
          </li>
          <li>
            <router-link
              to="/product"
              @click="showMobileMenu=false"
              :class="{ active: $route.name === 'product' }"
            >
              产品
            </router-link>
          </li>
        </ul>
      </div>
    </nav>
    <!-- 主要内容区域 -->
    <main class="insured-main">
      <div class="container">
        <!-- 投保按钮 -->
        <div class="insure-btn-wrap">
          <button
            class="insure-btn"
            @click="goToInsurePage"
          >
            立即投保
          </button>
        </div>

        <!-- 已投保数据列表 -->
        <div class="insured-list">
          <table>
            <thead>
            <tr>
              <th>保单号</th>
              <th>产品名称</th>
              <th>投保时间</th>
              <th>保费</th>
              <th>状态</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="item in currentPageData" :key="item.policyNo">
              <td>{{ item.policyNo }}</td>
              <td>{{ item.productName }}</td>
              <td>{{ item.insureTime }}</td>
              <td>¥{{ item.premium }}</td>
              <td>{{ item.status }}</td>
            </tr>
            </tbody>
          </table>
        </div>

        <!-- 分页控件 -->
        <div class="pagination">
          <button
            @click="currentPage > 1 && handlePageChange(currentPage - 1)"
            :disabled="currentPage === 1"
          >
            上一页
          </button>
          <span>第 {{ currentPage }} 页 / 共 {{ totalPages }} 页</span>
          <button
            @click="currentPage < totalPages && handlePageChange(currentPage + 1)"
            :disabled="currentPage === totalPages"
          >
            下一页
          </button>
        </div>
      </div>
    </main>

    <!-- 页脚 -->
    <footer class="footer">
      <div class="container">
        <p>© 2023 广东广福宏宇保险经纪有限公司 粤ICP备XXXXXXX号</p>
        <div class="footer-links">
          <a href="#about">关于我们</a>
          <a href="#contact">联系我们</a>
          <a href="#">隐私政策</a>
        </div>
      </div>
    </footer>

    <!-- 返回顶部按钮 -->
    <button
      class="back-to-top"
      v-show="showBackToTop"
      @click="scrollToTop"
    >↑</button>
  </div>
</template>

<script>

export default {
  name: 'product',
  data () {
    return {
      isMobile: false, // 移动端判断
      showMobileMenu: false, // 移动端菜单显示状态
      showBackToTop: false, // 返回顶部按钮显示状态
      // 分页相关状态
      currentPage: 1, // 当前页码
      pageSize: 10, // 每页显示数量
      total: 0, // 总数据量
      insuredList: [], // 全部已投保数据
      // 模拟已投保数据（实际应从接口获取）
      mockData: [
        { policyNo: 'P20240001', productName: '家庭财产险', insureTime: '2024-03-15', premium: 899, status: '生效中' },
        { policyNo: 'P20240002', productName: '车险', insureTime: '2024-02-20', premium: 1999, status: '已到期' }
        // 更多模拟数据...
      ]
    }
  },
  computed: {
    // 当前页数据（根据分页计算）
    currentPageData () {
      const start = (this.currentPage - 1) * this.pageSize
      const end = start + this.pageSize
      return this.insuredList.slice(start, end)
    },
    // 总页数
    totalPages () {
      return Math.ceil(this.total / this.pageSize)
    }
  },
  mounted () {
    this.handleResize()
    this.fetchInsuredData() // 初始化加载数据
    // 初始化移动端判断
    this.isMobile = window.innerWidth <= 768
    window.addEventListener('resize', this.handleResize)
    window.addEventListener('scroll', this.handleScroll)
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
    window.removeEventListener('scroll', this.handleScroll)
  },
  methods: {
    // 加载已投保数据（模拟接口调用）
    fetchInsuredData () {
      this.insuredList = this.mockData // 实际应替换为API请求
      this.total = this.mockData.length // 实际应从接口获取total
    },
    // 切换页码
    handlePageChange (page) {
      this.currentPage = page
    },
    // 跳转投保页面
    goToInsurePage () {
      this.$router.push('/orderInsZFG') // 替换为实际投保页面路由
    },
    // 窗口大小变化处理
    handleResize () {
      this.isMobile = window.innerWidth <= 768
      if (!this.isMobile) this.showMobileMenu = false
    },
    // 滚动事件处理
    handleScroll () {
      this.showBackToTop = window.scrollY > 300
    },
    // 返回顶部
    scrollToTop () {
      window.scrollTo({ top: 0, behavior: 'smooth' })
    }
  }
}
</script>
<style scoped>
/* 新增/修改样式 */
.homepage {
  display: flex;          /* 启用Flex布局 */
  flex-direction: column; /* 垂直排列子元素 */
  min-height: 100vh;      /* 至少占满整个视口高度 */
}

.product-main {
  flex: 1;                /* 内容区域自动扩展占据剩余空间 */
}
/* 页脚 */
.footer {
  background: #2c3e50;
  color: #fff;
  padding: 40px 0;
  text-align: center;
  margin-top: auto;       /* 页脚自动靠底部 */
}

.footer-links {
  margin-top: 20px;
  display: flex;
  gap: 20px;
  justify-content: center;
}

.footer-links a {
  color: #fff;
  text-decoration: none;
}

/* 返回顶部按钮 */
.back-to-top {
  position: fixed;
  bottom: 30px;
  right: 30px;
  background: #3498db;
  color: #fff;
  border: none;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  cursor: pointer;
  opacity: 0.8;
  transition: opacity 0.3s;
}

.back-to-top:hover {
  opacity: 1;
}
/* 基础样式 */
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

body {
  font-family: 'Microsoft YaHei', sans-serif;
  line-height: 1.6;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}
/* 移动端适配 */
@media (max-width: 768px) {
  .desktop-menu {
    display: none;
  }

  .hero {
    height: 60vh;
    margin-top: 60px;
  }

  .section {
    padding: 50px 0;
  }
}
/* 新增样式 */
.insured-main {
  margin-top: 100px; /* 导航栏高度 */
  padding: 20px 0;
}

.insure-btn-wrap {
  margin-bottom: 30px;
  text-align: right;
}

.insure-btn {
  background: #3498db;
  color: white;
  border: none;
  padding: 10px 25px;
  border-radius: 5px;
  cursor: pointer;
  font-size: 1rem;
}

.insured-list table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
}

.insured-list th, .insured-list td {
  padding: 12px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

.insured-list th {
  background: #f8f9fa;
}

.pagination {
  display: flex;
  gap: 20px;
  align-items: center;
  justify-content: center;
  margin-top: 30px;
}

.pagination button {
  padding: 8px 16px;
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
}

.pagination button:disabled {
  background: #f5f5f5;
  color: #999;
  cursor: not-allowed;
}
/* 导航栏 */
.navbar {
  position: fixed;
  top: 0;
  width: 100%;
  background: #fff;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  z-index: 1000;
  padding: 15px 0;
}

.navbar .container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.brand {
  font-size: 1.2rem;
  font-weight: bold;
  color: #2c3e50;
}

.desktop-menu {
  display: flex;
  gap: 30px;
}

.desktop-menu li a, .mobile-menu li a {
  color: #333;
  text-decoration: none;
  transition: color 0.3s;
}

.desktop-menu li a:hover {
  color: #3498db;
}

.mobile-menu-btn {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
}

.mobile-menu {
  position: absolute;
  top: 100%;
  left: 0;
  width: 100%;
  background: #fff;
  padding: 20px;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  display: flex;
  flex-direction: column;
  gap: 15px;
}
</style>



// WEBPACK FOOTER //
// src/views/insure/orderZFG.vue